
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPanelRightOpen as ObiPanelRightOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-panel-right-open.js';
 
 
 

 
 export const ObiPanelRightOpen = createComponent({
   react: React,
   tagName: 'obi-panel-right-open',
   elementClass: ObiPanelRightOpenElement,
   events: {
     
   }
  });
 
 